import { useCallback, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { mostPermissive } from '../permissions/access';

export default function useAccess() {
  const { elementState, hasPagePermission, hasCardPermission, isSuperuser, accessLoaded } = useContext(AuthContext);

  const stateOf = useCallback((key) => elementState(key), [elementState]);
  const can = useCallback((key) => elementState(key) === mostPermissive(key), [elementState]);

  return {
    can,
    stateOf,
    canOpenPage: hasPagePermission,
    canSeeCard: hasCardPermission,
    isSuperuser,
    ready: accessLoaded,
  };
}
